import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { HttpService, API, swal, Title, toast, Messages, DateFormat } from '../../../config/react'
// import { confirmWrapper, confirm } from '../../constants/Confirmation'
import DataTable from 'react-data-table-component'

const DiamondMarkup = () => {
  const [MarkupList, setMarkupList] = useState([])
  const [isForceUpdate, setForceUpdate] = useState(false)

  const columns = [
    {
      name: 'Carat From',
      selector: (row) => row.from_carat
    },
    {
      name: 'Carat To',
      selector: (row) => row.to_carat
    },
    {
      name: 'Markup Type',
      selector: (row) => (row.markup_type === 'percentage' ? 'Percentage' : 'Amount')
    },
    {
      name: 'Type',
      selector: (row) => (row.is_lab_diamond === 1 ? 'Lab Grown' : 'Earth Mined')
    },
    {
      name: 'Markup',
      selector: (row) => row.markup
    },
    {
      name: 'Cost',
      selector: (row) => row.fix_cost
    },
    {
      name: 'Created Date',
      selector: (row) => <DateFormat value={row.created_at}></DateFormat>
    },
    {
      name: 'Action',
      selector: (row) => (
        <div className="action-btn">
          <Link
            to={'/system/diamondmarkup/edit/' + row.ID}
            className="text-dark"
            title="Edit"
          >
            <i
              className="fa fa-pencil-square-o"
              aria-hidden="true"
            ></i>{' '}
          </Link>
          <Link
            onClick={(e) => DeleteMarkup(e, row.ID)}
            to=""
            className="text-dark"
            title="Delete"
          >
            <i
              className="fa fa-trash-o"
              aria-hidden="true"
            ></i>{' '}
          </Link>
        </div>
      )
    }
  ]

  const DefaultFilters = {
    page: 1,
    search: '',
    page_size: 10
  }
  const [CustomFilters, setCustomFilters] = useState(DefaultFilters)
  const [totalRows, settotalRows] = useState()

  useEffect(() => {
    document.title = Title.DiamondMarkup
    GetMarkupList()
  }, [CustomFilters])

  const GetMarkupList = () => {
    const passData = {
      page: CustomFilters.page,
      search: CustomFilters.search,
      page_size: CustomFilters.page_size
    }
    HttpService.postApi(API.GetDiamondMarkupAdmin, passData).then((response) => {
      if (response.data.status === true) {
        const data = response.data.result[1]
        // var data = response.data.result[0];

        setMarkupList(data)
        setForceUpdate(!isForceUpdate)
        settotalRows(response.data.result[0][0].total_row)
      }
    })
  }

  const handlePageChange = (e) => {
    setCustomFilters({ ...CustomFilters, page: e })
  }

  const handlePerRowsChange = (e) => {
    setCustomFilters({ ...CustomFilters, page_size: e })
  }

  const subHeaderComponentMemo = React.useMemo(() => {
    return (
      <input
        type="text"
        title="Search For Carat From, Carat To, Markup Type."
        className="form-control col-md-3"
        placeholder="Search"
        onChange={(e) => setCustomFilters({ ...CustomFilters, search: e.target.value })}
      />
    )
  })

  const DeleteMarkup = async (e, id) => {
    e.preventDefault()
    swal(Messages.SwalDeleteProp).then(function (isConfirm) {
      if (isConfirm) {
        const param = {
          id,
          IsDeleted: true
        }
        HttpService.postApi(API.DeleteDiamondMarkup, param).then((response) => {
          toast.success(Messages.RecordDeleted)
          GetMarkupList()
          setForceUpdate(!isForceUpdate)
        })
      }
    })
  }

  return (
    <div className="content-wrapper pb-0">
      <div className="page-header">
        <h3 className="page-title"> {Title.DiamondMarkup} </h3>
        <div className="btn-group">
          <Link
            to="/system/diamondmarkup/add"
            className="btn btn-dark btn-fw rounded mr-2"
          >
            {' '}
            Add Diamond Markup{' '}
          </Link>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <div className="table-responsive">
                <DataTable
                  columns={columns}
                  data={MarkupList}
                  pagination
                  paginationServer
                  paginationTotalRows={totalRows}
                  persistTableHead={true}
                  onChangeRowsPerPage={handlePerRowsChange}
                  onChangePage={handlePageChange}
                  subHeader
                  subHeaderComponent={subHeaderComponentMemo}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default DiamondMarkup
